import { IndexTable, Card, useBreakpoints } from '@shopify/polaris';
import TablePagination from './table_pagination';

export default function FixedTable({ useTable, maxHeight }) {
  return (
    <Card padding={0}>
      <div style={maxHeight ? { maxHeight: maxHeight, overflowY: 'auto' } : undefined}>
        <IndexTable
          condensed={useBreakpoints().smDown}
          itemCount={useTable.data.length}
          headings={useTable.headers}
          selectable={false}
        >
          {useTable.rowMarkup}
        </IndexTable>
      </div>
      {useTable.showPagination && <TablePagination useTable={useTable} />}
    </Card>
  );
}
